var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.useSup
    ? _c("span", { staticClass: "price-view" }, [
        _c("span", { staticClass: "priceUnits" }, [
          _c("span", { staticClass: "prefix" }, [
            _vm._v(_vm._s(_vm.currencyPrefix)),
          ]),
          _c("span", { staticClass: "units" }, [_vm._v(_vm._s(_vm.units))]),
          _c("span", { staticClass: "separator" }, [
            _vm._v(_vm._s(_vm.currencySeparator)),
          ]),
          _c(
            "sup",
            {
              class: {
                decimals: _vm.decimals.length > 1,
              },
            },
            [_vm._v(_vm._s(_vm.decimals))]
          ),
        ]),
        _vm._v(_vm._s(_vm.currencySuffix)),
      ])
    : _c("span", [
        _vm._v(
          _vm._s(_vm.currencyPrefix) +
            _vm._s(_vm.units) +
            _vm._s(_vm.currencySeparator) +
            _vm._s(_vm.decimals) +
            _vm._s(_vm.currencySuffix)
        ),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }